export const topBarHeights = { xs: 88, md: 104 } as const;
